var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "gmap-map",
        {
          ref: "map",
          staticClass: "gmap b122-gmap mt-2",
          attrs: {
            center: _vm.desiredCenter,
            options: _vm.gmapOptions,
            zoom: _vm.desiredZoom
          },
          on: {
            center_changed: _vm.onCenterChanged,
            zoom_changed: _vm.onZoomChanged,
            bounds_changed: _vm.onBoundsChanged,
            dragend: _vm.onMapDrag
          }
        },
        [
          _c(
            "GmapCluster",
            {
              attrs: {
                zoomOnClick: true,
                maxZoom: 16,
                styles: _vm.clusterStyles,
                calculator: _vm.clusterCalculator
              }
            },
            [
              _vm._l(_vm.theftMarkers, function(m, index) {
                return [
                  _c("gmap-marker", {
                    key: index,
                    attrs: {
                      clickable: m.clickable,
                      icon: _vm.getIcon(m.type),
                      position: m.position,
                      "z-index": m.zIndex
                    },
                    on: {
                      click: function($event) {
                        return _vm.onMarkerClick(index)
                      }
                    }
                  }),
                  _vm._v(" "),
                  index === _vm.currentlySelectedAnnonceIndex
                    ? _c("GmapCircle", {
                        key: index + "theftZone",
                        attrs: {
                          center: m.position,
                          options: {
                            fillColor: "#E74A49",
                            fillOpacity: 0.3,
                            strokeOpacity: 0,
                            clickable: false
                          },
                          radius: 1000,
                          visible: true
                        }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.policeMarkers, function(m, index) {
            return [
              _c(
                "gmap-marker",
                {
                  key: "police-m-" + index,
                  attrs: {
                    clickable: m.clickable,
                    icon: _vm.getIcon(m.type),
                    position: m.position,
                    "z-index": m.zIndex
                  },
                  on: {
                    click: function($event) {
                      return _vm.openMarker(index)
                    }
                  }
                },
                [
                  _c(
                    "gmap-info-window",
                    {
                      attrs: {
                        closeclick: true,
                        opened:
                          _vm.openedMarkerID === _vm.policeStations[index].id,
                        options: _vm.gmapInfoOptions
                      }
                    },
                    [
                      _c("div", { staticClass: "b122-gmap-info-window" }, [
                        _c(
                          "div",
                          { staticClass: "b122-gmap-info-window-title pb-2" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.policeStations[index].tostring) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.policeStations[index].address) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-3" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.policeStations[index].department.tostring2
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.policeStations[index].phoneNumber) +
                              "\n              "
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "display-list-btn-container" } }, [
        _c(
          "div",
          {
            staticClass: "display-list-btn bold-text cursor-pointer",
            on: {
              click: function($event) {
                return _vm.$emit("hideMap")
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("annonce.map.display.search")) +
                "\n      "
            ),
            _c("i", { staticClass: "ph-custom ph-list ml-2" })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "map-action-button cursor-pointer",
          on: { click: _vm.centerOnUser }
        },
        [_c("i", { staticClass: "ph-crosshair" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "map-action-button cursor-pointer",
          on: { click: _vm.onSearchFromCenterOfMap }
        },
        [_c("i", { staticClass: "ph-binoculars" })]
      ),
      _vm._v(" "),
      _vm.currentlySelectedAnnonceIndex !== null
        ? _c("div", { staticClass: "annonce-card-container" }, [
            _c(
              "div",
              { attrs: { id: "big-screen-annonce-list" } },
              [
                _c("annonce-card-image-left", {
                  key:
                    _vm.$props.annonces[_vm.currentlySelectedAnnonceIndex]
                      .serverId,
                  staticClass: "cursor-pointer annonce-card",
                  attrs: {
                    annonce:
                      _vm.$props.annonces[_vm.currentlySelectedAnnonceIndex]
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row" }, [
                  _vm.currentlySelectedAnnonceIndex !== 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "annonce-list-navigation-button cursor-pointer",
                          on: { click: _vm.onPreviousAnnonceClicked }
                        },
                        [_c("i", { staticClass: "ph-caret-left" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentlySelectedAnnonceIndex !==
                  _vm.$props.annonces.length - 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "annonce-list-navigation-button cursor-pointer",
                          on: { click: _vm.onNextAnnonceClicked }
                        },
                        [_c("i", { staticClass: "ph-caret-right" })]
                      )
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "small-screen-annonce-list" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "display-list-btn bold-text cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.$emit("hideMap")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "ph-custom ph-list mr-2" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("annonce.map.display.search.short")) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-carousel",
                  {
                    ref: "annonces-carousel",
                    attrs: {
                      id: "map-annonces-carousel",
                      interval: 0,
                      "no-wrap": ""
                    },
                    on: { "sliding-start": _vm.onCarouselSliding },
                    model: {
                      value: _vm.currentlySelectedAnnonceIndex,
                      callback: function($$v) {
                        _vm.currentlySelectedAnnonceIndex = $$v
                      },
                      expression: "currentlySelectedAnnonceIndex"
                    }
                  },
                  _vm._l(_vm.$props.annonces, function(annonce, index) {
                    return _c("b-carousel-slide", {
                      key: annonce.serverId,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("annonce-card-image-left", {
                                  staticClass: "cursor-pointer annonce-card",
                                  attrs: { annonce: annonce }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-626ae25e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-626ae25e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/AnnoncesMap.vue
// module id = ptHG
// module chunks = 0